import store from 'store2';

export const setVolume = (volume: number) => store.set('volume', Number(volume.toFixed(2)));

export const getVolume = (): number | null => store.get('volume');

export const setMutedStatus = (status: boolean) => store.set('is_muted', status);

export const getMutedStatus = (): boolean => store.get('is_muted');
